/**
 * Hook que consume /api/v1/env-info/ (público, sin auth) y expone el label
 * del ambiente. Permite mostrar banners/identificadores tipo "QA — sin validez".
 */
import { useQuery } from '@tanstack/react-query'
import apiClient from '@/lib/apiClient'

export interface EnvInfo {
  env_label: string
  is_production: boolean
}

export function useEnvInfo() {
  return useQuery({
    queryKey: ['env-info'],
    queryFn: async () => {
      const r = await apiClient.get<EnvInfo>('/env-info/')
      return r.data
    },
    staleTime: 60 * 60 * 1000, // 1h: el label no cambia entre deploys
  })
}
